import React, { Component } from 'react';

import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';
import { ToBiEmojis } from '@vfgroup-oneplatform/foundation/ToBi';
import Navigation from '@vfgroup-oneplatform/foundation/Utils/Navigation';
import { isFunction as _isFunction } from 'lodash';
import PropTypes from 'prop-types';

import Status from '../../Utils/AuthStatusEnum';
import LoginTestKeys from '../../Utils/LoginTestKeys';
import AuthContainer from '../AuthContainer/AuthContainer';

import SavedAccountsView from './SavedAccountsView';

class SavedAccounts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startAnimation: false,
      tobiEmoji: undefined,
      isLoading: false,
      savedAccountsList: Navigation.instance.getParam(this, 'savedAccounts', []),
    };
  }

  onRegisterPress = () => {
    const onRegister = Navigation.instance.getParam(this, 'onRegister', () => null);
    onRegister();
  };

  onOurPrivacyPress = () => {
    const onThirdLabelPress = Navigation.instance.getParam(this, 'onThirdLabelPress', () => null);
    _isFunction(onThirdLabelPress) && onThirdLabelPress();
  };

  onLoginPress = async user => {
    const onSuccess = Navigation.instance.getParam(this, 'onSuccess', () => null);
    const onLogin = Navigation.instance.getParam(this, 'onLogin', () => null);

    this.setState({
      tobiEmoji: ToBiEmojis.Whistle,
      isLoading: true,
    });

    try {
      const result = await onLogin(user);
      if (result.status === Status.Success) {
        onSuccess(result.response, result);
        this.setState({
          tobiEmoji: undefined,
          isLoading: false,
        });
      }
    } catch (error) {
      this.setState({
        tobiEmoji: undefined,
        isLoading: false,
      });
    }
  };

  onEndAnimation = () => {
    this.setState({ startAnimation: false, tobiEmoji: undefined });
  };

  onDeleteAccount = async selectedAccount => {
    const onDeleteAccount = Navigation.instance.getParam(this, 'onDeleteAccount', () => {});
    await onDeleteAccount(selectedAccount);
    this.getSavedAccountsList();
  };
  getSavedAccountsList = async () => {
    const getSavedAccountsList = Navigation.instance.getParam(
      this,
      'getSavedAccountsList',
      () => {},
    );
    const newAccountList = await getSavedAccountsList();
    this.setState({ savedAccountsList: newAccountList });
  };
  render() {
    const { startAnimation, tobiEmoji, isLoading, savedAccountsList } = this.state;
    const { theme } = this.props;

    const renderFooter = Navigation.instance.getParam(this, 'renderFooter', () => {});
    const getThemeImages = Navigation.instance.getParam(this, 'getThemeImages', () => {});
    const onUpfrontLogin = Navigation.instance.getParam(this, 'onUpfrontLogin', () => {});
    const withThirdLabel = Navigation.instance.getParam(this, 'withThirdLabel', false);
    const withFirstLabel = Navigation.instance.getParam(this, 'withFirstLabel', true);
    const withSecondLabel = Navigation.instance.getParam(this, 'withSecondLabel', true);

    const getAccountIconBasedOnType = Navigation.instance.getParam(
      this,
      'getAccountIconBasedOnType',
      () => {},
    );

    const renderTitle = !isLoading
      ? Navigation.instance.getParam(this, 'renderTitle', () => {})
      : () => {};

    return (
      <React.Fragment>
        <AuthContainer
          withFirstLabel={withFirstLabel}
          withSecondLabel={withSecondLabel}
          withThirdLabel={withThirdLabel}
          firstLabelTitle="choose_account_type_not_registered_with_my_vodafone_label"
          secondLabelTitle="choose_account_type_register_now_button"
          thirdLabelTitle="upfront_our_privacy_label"
          firstLabelDisabled
          secondLabelOnPress={this.onRegisterPress}
          thirdLabelOnPress={this.onOurPrivacyPress}
          firstLabelTestID={LoginTestKeys.loginNotRegisteredTxt}
          secondLabelTestId={LoginTestKeys.loginRegisterNowLinkSaved}
          tobiSize={114}
          tobiEmoji={tobiEmoji}
          renderTobiLessIconView={Navigation.instance.getParam(this, 'renderLoginIconView', null)}
          renderFooter={renderFooter}
          renderTitle={renderTitle}
          onEndAnimation={this.onEndAnimation}
          childrenContainerAccessibilityLabel={LoginTestKeys.loginView}
          startAnimation={startAnimation}
          tobiTestId={LoginTestKeys.loginAuthContainerTobiIcon}
          isLoading={isLoading}
          loadingText="verification_loading_login_text"
        >
          <SavedAccountsView
            savedAccounts={savedAccountsList}
            onAccountPress={this.onLoginPress}
            images={getThemeImages(theme.name)}
            getAccountIconBasedOnType={getAccountIconBasedOnType}
            onUpfrontLogin={onUpfrontLogin}
            onDeleteAccount={this.onDeleteAccount}
          />
        </AuthContainer>
      </React.Fragment>
    );
  }
}

SavedAccounts.defaultProps = {
  theme: LightThemeColors,
};

SavedAccounts.propTypes = {
  theme: PropTypes.object,
  navigation: PropTypes.object.isRequired,
};

export default withTheme(SavedAccounts);
